export const Theme = {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    red: '#D50032',
    redAlpha: '#D5003233',
    redDark: '#B1042C',
    redDarkAlpha: '#B1042C33',
    purple: '#6F5091',
    purpleAlpha: '#6F509133',
    purpleDark: '#40334E',
    purpleDarkAlpha: '#40334E59',
    greyHover: '#F1F1F1',
    greyLight: '#D9D9D6',
    greyMedium: '#A6A6A3',
    greyDark: '#63666A',
    greyDarkAlpha: '#63666ABF',
    blueLight: '#00D0FF',
    blueLightAlpha: '#00D0FF59',
    blueMedium: '#00AFD7',
    blueMediumAlpha: '#00afd733',
    blueDark: '#0076A8',
    blueDarkAlpha: '#0076A833',
    blueGrey: '##3B3F5C',
    blueGreyAlpha: '#52607959',
    green: '#00AF77',
    greenAlpha: '#00AF7733',
    yellow: '#FCD600',
    yellowAlpha: '#FCD6004D',
    orange: '#FF9800',
    orangeAlpha: '#FF980033'
  },
  shadows: {
    depth1: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    depth2: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    depth3: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
    depth4: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    depth5: '0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)'
  },
  typography: {
    heading1: '34px',
    heading2: '30px',
    heading3: '26px',
    heading4: '23px',
    heading5: '18.5px',
    heading6: '14.75px',
    subHeading: '14.75px',
    bodyText: '13.15px',
    smallText: '13.15px',
    captionText: '13.15px'
  }
};

// MEDIA QUERYS

// Value         |0px     600px    960px    1280px   1920px
// Key           |xs      sm       md       lg       xl
// Screen        |--------|--------|--------|--------|-------->
// Range         |   xs   |   sm   |   md   |   lg   |   xl